// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"LibraryChooser_selectWrapper__1qa2K","selectField":"LibraryChooser_selectField__r-TeQ"};